let SCRIPT_LOADED = false;
let ERROR_HANDLED = false;

const SCRIPT_LOAD_TIMEOUT = 3000;

function handleScriptLoaded(
  resolveHandler: (script: HTMLScriptElement) => void,
  script: HTMLScriptElement,
  customOnLoad?: () => void
) {
  return () => {
    resolveHandler(script);
    if (customOnLoad) {
      customOnLoad();
    }
    SCRIPT_LOADED = true;
  };
}

function handleScriptLoadError(
  rejectHandler: (reason: string) => void,
  customOnError?: () => void,
  concreteReason?: string
) {
  return () => {
    if (!ERROR_HANDLED) {
      rejectHandler(`External script load error${concreteReason || ""}`);
      if (customOnError) {
        customOnError();
      }
      ERROR_HANDLED = true;
    }
  };
}

export const appendExternalScript = async (
  url: string,
  scriptAttributes: { [key: string]: string } = {},
  setLoadingState?: () => void,
  customOnLoad?: () => void,
  customOnError?: () => void
): Promise<HTMLScriptElement> => {
  const head = document.querySelector("head");
  const scriptExists = head?.querySelector(`script[src="${url}"]`);

  if (scriptExists)
    return new Promise<HTMLScriptElement>((resolve) => {
      resolve(scriptExists as HTMLScriptElement);
    });
  if (setLoadingState) {
    setLoadingState();
  }
  const script = document.createElement("script");
  script.setAttribute("src", url);

  if (Object.keys(scriptAttributes).length > 0) {
    Object.keys(scriptAttributes).forEach((key) => {
      script.setAttribute(key, scriptAttributes[key]);
    });
  }

  return new Promise<HTMLScriptElement>((resolve, reject) => {
    script.onload = handleScriptLoaded(resolve, script, customOnLoad);
    script.onerror = handleScriptLoadError(reject, customOnError);

    head?.appendChild(script);

    setTimeout(() => {
      if (!SCRIPT_LOADED) {
        handleScriptLoadError(reject, customOnError, `Timeout ${SCRIPT_LOAD_TIMEOUT}ms`)();
      }
    }, SCRIPT_LOAD_TIMEOUT);
  });
};
